import { PageSlugs } from "../../add-element/types";
import { IsPreviewOrDemoProvider } from "../../contexts/IsPreviewOrDemoContext";
import { withInvalidRouteRedirect } from "../../core/routing";
import Paragraphs from "../../pages/website/Paragraphs";
import {
  getAllResources,
  getResource,
  filterPage,
  selectSite,
} from "../selectors";
import FancyClothesProvider from "./FancyClothesProvider";
import Footer from "./Footer";
import WebsiteHeader from "./WebsiteHeader";
import WebsitePages from "./WebsitePages";
import { css, Global } from "@emotion/react";
import { GlobalStyles } from "@minted/minted-components";
import get from "lodash/get";
import isEqual from "lodash/isEqual";
import React, { Component } from "react";
import { connect } from "react-redux";

export class Website extends Component {
  shouldComponentUpdate(nextProps) {
    return !isEqual(nextProps, this.props);
  }

  render() {
    const { pages, resources, route, site, themeAuthor } = this.props;
    const filteredPages = pages.filter((page) =>
      filterPage(page, {
        ...resources,
        sites: [site],
      }),
    );

    let activePage = filteredPages.find((page) => page.slug === route.name);

    if (!activePage) {
      activePage = filteredPages.find((page) => page.slug === PageSlugs.Home);
    }

    const pagesToRender =
      site.pageConfiguration === "multi_page" ? [activePage] : filteredPages;

    const useCondensedHeader =
      site.pageConfiguration === "multi_page" &&
      activePage.slug !== PageSlugs.Home;

    const textAlignment = get(activePage, "configuration.textAlignment");

    const customCssElement = site.extraCss ? (
      <Global
        styles={css`
          ${site.extraCss}
        `}
      />
    ) : null;

    return (
      <FancyClothesProvider>
        <GlobalStyles />
        {customCssElement}
        <IsPreviewOrDemoProvider
          isDemo={Boolean(site.isDemoSite)}
          isPreview={false}
        >
          <div id="page-home">
            <WebsiteHeader condensed={useCondensedHeader} pages={filteredPages}>
              <Paragraphs
                text={site.welcomeText || ""}
                textAlignment={textAlignment}
              />
            </WebsiteHeader>
          </div>
          <WebsitePages
            pages={pagesToRender}
            resources={resources}
            site={site}
            source="website"
          />
          <Footer artist={themeAuthor} />
        </IsPreviewOrDemoProvider>
      </FancyClothesProvider>
    );
  }
}

const mapStateToProps = (state) => {
  const site = selectSite(state.resources.sites);

  const pages = getResource(state.resources.pages);
  const resources = getAllResources(state.resources);

  return {
    pages,
    resources,
    site,
    themeAuthor: state.theme.attribution,
  };
};

// Apply Redux connection and route redirect handling
export default withInvalidRouteRedirect(connect(mapStateToProps)(Website), {
  injectRoute: true,
  redirectTo: PageSlugs.Home,
});
